import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download, Eye, Trash2 } from "react-feather";
import { Dropdown, Spinner } from "react-bootstrap";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import * as XLSX from "xlsx";

const AllServiceRequestAdmin = () => {
  const [requests, setRequests] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // Modal for full issue
  const [showModal, setShowModal] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Fetch all service applications
  const fetchRequests = async () => {
    try {
      const res = await axios.get(`${baseurl}getAllServiceApplications`);
      if (res.data.success) {
        setRequests(res.data.data);
        setFilteredData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching service applications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // Search
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);

    setFilteredData(
      requests.filter((item) =>
        `${item.customer_name} ${item.instrument_name} ${item.service_man_name}`
          .toLowerCase()
          .includes(term)
      )
    );

    setCurrentPage(1);
  };

  // Delete service request
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this request?")) return;

    try {
      await axios.delete(`${baseurl}deleteServiceApplicationById/${id}`);
      fetchRequests();
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Error deleting request");
    }
  };

  // Pagination Logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>All Service Requests</h4>

            <div className="d-flex align-items-center">
              <input
                type="text"
                value={search}
                className="form-control me-2"
                placeholder="Search Requests"
                onChange={handleSearch}
              />

            

              <button
                className="btn btnsuccess"
                onClick={() => {
                  const ws = XLSX.utils.json_to_sheet(filteredData);
                  const wb = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(wb, ws, "Service Requests");
                  XLSX.writeFile(wb, "service_requests.xlsx");
                }}
              >
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-body table-responsive">
              {loading ? (
                <div className="text-center my-5">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Customer</th>
                        <th>Contact</th>
                        <th>Instrument</th>
                        <th>Model</th>
                        <th>Issue</th>
                        <th>Document</th>
                        <th>Video</th>
                        <th>Service Man</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentRecords.map((item, index) => (
                        <tr key={item.id}>
                          <td>{indexOfFirstRecord + index + 1}</td>

                          <td>
                            {item.customer_name}
                            <br />
                            <small>{item.customer_email}</small>
                          </td>

                          <td>{item.customer_contact}</td>

                          <td>{item.instrument_name}</td>
                          <td>{item.model_number}</td>

                          {/* Issue trimmed to 25 chars */}
                          <td
                            style={{ maxWidth: "200px", cursor: "pointer", color: "blue" }}
                            onClick={() => {
                              setSelectedIssue(item.technical_issue);
                              setShowModal(true);
                            }}
                          >
                            {item.technical_issue?.length > 25
                              ? item.technical_issue.substring(0, 25) + "..."
                              : item.technical_issue}
                          </td>

                          <td>
                            {item.document_file ? (
                              <a
                                href={`${imageUrl}serviceapplications/${item.document_file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>

                          <td>
                            {item.video_file ? (
                              <a
                                href={`${imageUrl}serviceapplications/${item.video_file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Watch
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>

                          <td>{item.service_man_name}</td>

                          <td>
                            <span
                              className={`badge ${
                                item.status === "pending"
                                  ? "bg-warning"
                                  : item.status === "approved"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>

                          <td>{new Date(item.created_at).toLocaleDateString()}</td>

                          <td>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(item.id)}
                            >
                              <Trash2 size={15} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <nav>
                    <ul className="pagination justify-content-end">
                      {[...Array(totalPages)].map((_, i) => (
                        <li
                          key={i}
                          className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          <span className="page-link">{i + 1}</span>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ------------ ISSUE MODAL ------------ */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Technical Issue Details</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>

              <div className="modal-body">
                <p style={{ whiteSpace: "pre-line" }}>{selectedIssue}</p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllServiceRequestAdmin;
